import { Button } from '@components/Button';
import React from 'react';

interface BlackBannerProps {
  title: string;
  description: string;
  button?: {
    text: string;
    link: {
      href: string;
    };
  };
}

export const BlackBanner: React.FC<BlackBannerProps> = props => {
  return (
    <div className="relative isolate flex justify-between overflow-hidden rounded bg-gray-900 px-6 py-6 shadow-2xl sm:rounded-lg sm:px-10">
      <div className="">
        <h2 className="mx-auto text-lg font-bold tracking-tight text-white sm:text-xl">
          {props.title}
        </h2>
        <p className="mx-auto mt-1 text-base leading-8 text-gray-300">{props.description}</p>
      </div>
      {props.button && (
        <div className="ml-2 flex items-center">
          <Button color="white" link={{ href: props.button.link.href }}>
            {props.button.text}
          </Button>
        </div>
      )}
      <svg
        viewBox="0 0 512 512"
        className="absolute left-1/2 top-1/2 -z-10 h-[32rem] w-[32rem] -translate-x-1/2 [mask-image:radial-gradient(closest-side,white,transparent)]"
        aria-hidden="true"
      >
        <circle
          cx={256}
          cy={256}
          r={256}
          fill="url(#827591b1-ce8c-4110-b064-7cb85a0b1217)"
          fillOpacity="0.7"
        />
        <defs>
          <radialGradient id="827591b1-ce8c-4110-b064-7cb85a0b1217">
            <stop stopColor="#7775D6" />
            <stop offset={1} stopColor="#E935C1" />
          </radialGradient>
        </defs>
      </svg>
    </div>
  );
};
